// Theme constants & helpers — extracted from legacy-utils.ts

export const THEME_NIGHT_BLUE_COOKIE_VALUE = "kendo.custom";
export const THEME_NIGHT_GREY_COOKIE_VALUE = "kendo.customGrey";
export const THEME_DAY_COOKIE_VALUE = "";

export enum HelpDeskType {
  Home = 1,
  CADGettingStarted,
  MDTGettingStarted,
  AdminGettingStarted
}

export function setIOSThemeLightMode(): void {
  (window as any).updateThemeColor?.(THEME_DAY_COOKIE_VALUE);
}

export function setIOSThemeDarkMode(): void {
  (window as any).updateThemeColor?.(THEME_NIGHT_BLUE_COOKIE_VALUE);
}
